// utils/backendConfig.js
// Configuration centralisée de l'URL backend pour tous les composants
// VERSION CORRIGÉE - Force utilisation API Vercel relative
// Rebuild trigger: 2026-01-14 22:58:21
export const getBackendUrl = () => {
  const hostname = window.location.hostname;
  // Sur Vercel: toujours utiliser les routes API relatives
  if (hostname.includes('vercel.app')) {
    return '';  // Utilise les routes API de Vercel /api
  }
  // Variable d'environnement (priorité pour prod)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Localhost pour développement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }
  // Fallback: URL vide pour utiliser les routes API locales
  console.warn('[BACKEND URL] Utilisation des routes API Vercel');
  return '';
};
export default getBackendUrl;